<div class="messages"><Message v-for="({ type, text, persist }, id) in allMessages" :type="type" :text="text" :persist="persist" :key="id"></Message></div>